<div class="my-fleet-create-cutomer-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1" />
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14 font-white">
            {{myFleetTitle()}}
          </p>
        </div>
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>
  <div class="tire-modal-wrapper">
    <!-- Start Add Tire Body -->
    <div class="ui-12-g tire-body p-0 border-bottom-light">
      <div class="row tire-body-row m-0">
        <!-- Column 2: List of Items -->
        <div class="col-2 tire-navigation pl-0 pr-1">
          <ul>
            <li class="mt-1 pl-1" [class.active]="activeIndex !== 5">
              {{customerTitle}}
            </li>
            <li *ngFor="let section of sections; let i = index" [class.active]="activeIndex === i"
              [ngClass]="section.title === 'New vehicle'?'mt-1 pl-1': 'pl-3'" (click)="scrollToContent(i)">
              <div>
                {{
                !vehicle?._id && section.title === 'New vehicle' ?
                'Create Vehicle':
                vehicle?._id && section.title === 'New vehicle' ? 'Update vehicle'
                :section.title}}
              </div>
            </li>
          </ul>
        </div>

        <div class="col-10 tire-navigation-content pr-0 pl-1">
          <div class="scroll-wrapper">
            <div class="scroll-wrapper-inner" (scroll)="onScroll($event)" #contentContainer>
              <div *ngFor="let section of sections; let i = index" class="sections-wrapper" [id]="'content-' + i">
                <h3 class="">
                  {{
                  !vehicle?._id && section.title === 'New vehicle' ?
                  'Create Vehicle':
                  vehicle?._id && section.title === 'New vehicle' ? 'Update vehicle'
                  :section.title}}
                </h3>
                <div *ngIf="section.title === 'Basic Information'">
                  <div class="row">
                    <div class="col-12 mt-2">
                      <app-auto-complete placeholder="Search customer by fleet name, fleet code, or VIN"
                        [autoFocus]="focus?.fleet" styleClassListWrapper="width-100p mt-1" theme="border"
                        leftIcon="fal fa-search font-gray" [hasSearchIcon]="true" field="name" [fontSize]="14"
                        [value]="searchQuery" scrollHeight="350px" itemWidth="450px" [closeOnSelection]="true"
                        [hasEditableField]="false" [hasCustomListTemplate]="true" [hasCustomEditableField]="true"
                        (appCompletedMethod)="searchFleetSuggestion($event)" [disabled]="isCustomerDisabled"
                        (appChange)="handleSearchValue($event, true)" (appClear)="onClearSuggestion(true)">
                        <ng-template let-close="close" let-query="query" appTemplate="list">
                          <div class="scroller h-450 mt-1" *ngIf="!isLoadingFleet && fleetSuggestion.length > 0">
                            <div class="flex-between-center fleet-hover" *ngFor="let fleet of fleetSuggestion;"
                              (click)="onSelectFleet(fleet)">
                              <div class="mt-2 mb-2 ml-3">
                                <div class="font-16 font-gray-700 font-600">
                                  <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1 width-20px" />
                                  {{ fleet?.fleetName }}
                                  <ng-container *ngIf="fleet?.fleetCode"> | {{ fleet.fleetCode }} </ng-container>
                                  <ng-container *ngIf="fleet?.accountType"> | {{ fleet.accountType }} </ng-container>
                                </div>
                                <div class="font-gray-500 font-11 font-400 ml-26">
                                  Company: {{ fleet?.company }}
                                </div>
                              </div>

                              <div class="font-13 font-gray-700 font-400 mr-3">
                                {{ fleet?.phone }}
                                <ng-container *ngIf="fleet?.phone && fleet?.email"> | </ng-container>
                                {{ fleet?.email }}
                              </div>
                            </div>
                          </div>
                          <div class="no-fleet" *ngIf="searchQuery && !isLoadingFleet && fleetSuggestion.length === 0">
                            <img src="assets/no-fleet-customer.svg" class="" />
                            <div class="ml-4 flex-mid-center">
                              <div class="font-16 font-700 font-black">
                                No results found in MyFleetCenter
                              </div>
                              <div class="font-14 font-400 font-black mt-2">
                                Please retry with a different fleet name, code, or VIN. Click cancel if you would like
                                to create the customer manually.
                              </div>
                            </div>
                          </div>
                          <div class="hight50 flex-center-center" *ngIf="isLoadingFleet">
                            <i class="far fa-spinner rotate"></i>
                          </div>

                        </ng-template>
                      </app-auto-complete>
                    </div>


                    <div class="col-7 flex-start-center input-col input-control-container">
                      <div class="width-100p">
                        <label for="fleet-name">Fleet name</label>
                        <app-input id="fleet-name" placeholder="Enter fleet name" theme="border" disabled="true"
                          styleClass="partstech-item" [value]="basicInfo?.fleetName">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-5 flex-start-center input-col input-control-container">
                      <div class="width-100p">
                        <label for="fleet-number">Fleet Number</label>
                        <app-input id="fleet-number" placeholder="Enter fleet number" theme="border" disabled="true"
                          [value]="selectedVehicle?.year" styleClass="partstech-item" [value]="basicInfo?.fleetCode">
                        </app-input>

                      </div>
                    </div>
                    <div class="col-7 flex-start-center input-col mt-2">
                      <div class="width-100p">
                        <label for="tire-size">Company</label>
                        <app-input id="tire-size" placeholder="Enter company" theme="border" disabled="true"
                          [value]="basicInfo?.company">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-5 flex-start-center input-col mt-2">
                      <div class="width-100p">
                        <label for="tire-size">Fleet type</label>
                        <div class="my-fleet-type-badge">{{basicInfo?.accountType || 'local'}}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="section.title === 'Authorizer details'">
                  <app-myfleet-customer-dialog-address
                    [fleet]="authorizerDetails"></app-myfleet-customer-dialog-address>
                </div>

                <div *ngIf="section.title === 'Contact details'">
                  <app-myfleet-customer-dialog-address [fleet]="contactDetails"></app-myfleet-customer-dialog-address>
                </div>

                <div *ngIf="section.title === 'Shipping details'">
                  <app-myfleet-customer-dialog-address [fleet]="shippingDetails"></app-myfleet-customer-dialog-address>
                </div>

                <div *ngIf="section.title === 'Fleet overrides'" class="mt-3">
                  <my-fleet-override-setting [displayName]="basicInfo?.fleetName" [errors]="errors"
                    (handleDataChange)=" updateFleetSettings($event)">
                  </my-fleet-override-setting>
                </div>

                <div *ngIf="section.title === 'New vehicle'">
                  <div class="row mt-3">
                    <div class="col-12">
                      <app-auto-complete placeholder="Search vehicle by VIN" styleClassListWrapper="width-100p mt-1"
                        theme="border" leftIcon="fal fa-search font-gray" [hasSearchIcon]="true" field="name"
                        [autoFocus]="focus?.vehicle" [fontSize]="14" [value]="searchVehicleQuery" scrollHeight="200px"
                        itemWidth="450px" [closeOnSelection]="true" [hasEditableField]="false"
                        [hasCustomListTemplate]="true" [hasCustomEditableField]="true"
                        (appFocus)="handleShowSuggestion()" (appCompletedMethod)="searchFleetVehicleSuggestion($event)"
                        [disabled]="!basicInfo?.fleetCode" (appChange)="handleSearchValue($event)"
                        (appClear)="onClearSuggestion(false)">
                        <ng-template let-close="close" let-query="query" appTemplate="list">
                          <div class="scroller h-450 mt-1"
                            *ngIf="!isLoadingFleet && vehicleSuggestion.length > 0 && showSuggestionForm">
                            <div class="flex-between-center fleet-hover" *ngFor="let vehicle of vehicleSuggestion;"
                              (click)="onSelectVehicleFleet(vehicle)">
                              <div class="mt-2 mb-2 ml-3">
                                <div class="font-16 font-gray-700 font-600">
                                  <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1 width-20px" />
                                  {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
                                </div>
                              </div>
                              <div class="font-13 font-gray-700 font-400 mr-3">
                                VIN: {{ vehicle.vin }}
                                &nbsp;<ng-container *ngIf="vehicle?.plateNumber"> | License plate: {{
                                  vehicle.plateNumber
                                  }} </ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="no-fleet"
                            *ngIf="searchVehicleQuery && !isSearchingVehicleRecords && vehicleSuggestion.length === 0">
                            <img src="assets/no-fleet-customer.svg" class="" />
                            <div class="ml-4 flex-mid-center">
                              <div class="font-16 font-700 font-black">
                                No results found in MyFleetCenter
                              </div>
                              <div class="font-14 font-400 font-black mt-2">
                                Please retry with a different VIN. Click cancel if you would like
                                to create the customer manually.
                              </div>
                            </div>
                          </div>
                          <div class="hight50 flex-center-center" *ngIf="isSearchingVehicleRecords">
                            <i class="far fa-spinner rotate"></i>
                          </div>
                        </ng-template>
                      </app-auto-complete>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="row col-7 justify-content-center">
                      <div class="pl-0 pr-1 col-4 flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-year">Year</label>
                          <app-input id="vehicle-year" placeholder="Enter year" theme="border" disabled="true"
                            [value]="selectedVehicle?.year" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                      <div class="pr-1 col-4 flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-make">Make</label>
                          <app-input id="vehicle-make" placeholder="Enter make" theme="border" disabled="true"
                            [value]="selectedVehicle?.make" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                      <div class="pr-1 col-4 flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-Model">Model</label>
                          <app-input id="vehicle-Model" placeholder="Enter model" theme="border" disabled="true"
                            [value]="selectedVehicle?.model" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>

                    </div>
                    <div class="col-5 pr-0 pl-4">
                      <div class="flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-mileage">Mileage</label>
                          <app-input id="vehicle-mileage" placeholder="Enter mileage" theme="border" disabled="true"
                            [value]="selectedVehicle?.mileage" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row justify-content-center">
                    <div class="row col-7 justify-content-center">
                      <div class="pl-0 pr-1 col-8 flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-vin">VIN</label>
                          <app-input id="vehicle-vin" placeholder="Enter VIN" theme="border" disabled="true"
                            [value]="selectedVehicle?.vin" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                      <div class="pr-1 col-4 flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-license-plate">License plate</label>
                          <app-input id="vehicle-license-plate" placeholder="Enter license plate" theme="border"
                            disabled="true" [value]="selectedVehicle?.plateNumber" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                    </div>
                    <div class="col-5 pr-0 pl-4">
                      <div class="flex-start-center input-col input-control-container ">
                        <div class="width-100p ">
                          <label for="vehicle-reg-state">Registration state</label>
                          <app-input id="vehicle-reg-state" placeholder="Enter registration state" theme="border"
                            disabled="true" [value]="selectedVehicle?.state" styleClass="partstech-item">
                          </app-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12 dialog-footer part-footer p-0">
        <div class="part-add-dialog-footer width-100p flex-end-center">
          <div>
            <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
            <button class="btn btn-primary btn-submit" (click)="handleSubmit()"
              [disabled]="isProcessing || !basicInfo?.fleetCode || isCustomerDisabled && !selectedVehicle?.vin">
              <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
              <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>